var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconYouTubeWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7908 6.3002C20.7908 6.3002 20.5857 4.85234 19.9541 4.2166C19.1543 3.37988 18.2602 3.37578 17.85 3.32656C14.9133 3.11328 10.5041 3.11328 10.5041 3.11328H10.4959C10.4959 3.11328 6.08672 3.11328 3.15 3.32656C2.73984 3.37578 1.8457 3.37988 1.0459 4.2166C0.414258 4.85234 0.213281 6.3002 0.213281 6.3002C0.213281 6.3002 0 8.00234 0 9.70039V11.2918C0 12.9898 0.20918 14.692 0.20918 14.692C0.20918 14.692 0.414258 16.1398 1.0418 16.7756C1.8416 17.6123 2.8916 17.5836 3.35918 17.6738C5.04082 17.8338 10.5 17.883 10.5 17.883C10.5 17.883 14.9133 17.8748 17.85 17.6656C18.2602 17.6164 19.1543 17.6123 19.9541 16.7756C20.5857 16.1398 20.7908 14.692 20.7908 14.692C20.7908 14.692 21 12.9939 21 11.2918V9.70039C21 8.00234 20.7908 6.3002 20.7908 6.3002ZM8.33027 13.2236V7.32148L14.0027 10.2828L8.33027 13.2236Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYouTubeWhite);
export default __webpack_public_path__ + "static/media/icon-YouTube-white.5743d6c311ea0c2d6f6def89e7b8eae8.svg";
export { ForwardRef as ReactComponent };